import { render, staticRenderFns } from "./VATRates.vue?vue&type=template&id=ed0b3e2e&"
import script from "./VATRates.vue?vue&type=script&lang=js&"
export * from "./VATRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports